module.exports = __webpack_public_path__ + "media/images/pagetitles/photos-28dd2943753d0b19130447e13140c88f.gif";